import fileInKiB from "./fileInKiB";

const rejectionReasons = (file, filesState, acceptedMimeTypes, { fileType, maxSize, minSize, multiple }) => {
  const errors = [];

  if (file.size > maxSize) errors.push(`File exceeds the maximum size of ${fileInKiB(maxSize)} KiB`);
  if (file.size < minSize) errors.push(`File is smaller than the minimum size required ${fileInKiB(minSize)} KiB`);
  if (filesState.length > 1 && !multiple) errors.push(`Only one file allowed at a time`);
  if (!acceptedMimeTypes.includes(file.type)) errors.push(`File type not accepted - ${file.type}`);

  return errors;
};

export default rejectionReasons;
